import PageTitle from "../../../components/partials/PageTitle";
import {
  useNavigate,
  useLocation,
  Link,
  useOutletContext,
} from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Form from "../../../components/form/Form";
import useInputChange from "../../../utils/hooks/useInputChange";
import { useSelector } from "react-redux";
import useFileSelected from "../../../utils/hooks/useFileSelected";
import { isEmptyObject } from "./../../../utils/validators/validators";
import { useDispatch } from "react-redux/";
import {
  addStaffEducationalInfo,
  resetStaffStatus,
} from "../../../redux/slice/staff/staffSlice";
import Preview from "../../../components/modals/preview/document";
import Swal from "sweetalert2";
import { removeStaffEducationalInfo } from "./../../../redux/slice/staff/staffSlice";

const AddEducationInfo = () => {
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { app_id, isLoading, isError, isSuccess, staff_records, pages } =
    useSelector((state) => state.staff);
  const [currentEducationalInfo, setCurrentEducationalInfo] = useState([]);
  const { nextPage } = useOutletContext();

  const [error, setError] = useState({});
  const certicateRef = useRef();

  // initialize input fields
  const [staffInputData, setStaffInputData] = useState({
    institution_name: "",
    start_date: new Date().toISOString().slice(0, 10),
    end_date: new Date().toISOString().slice(0, 10),
    course_of_study: "",
    document: {},
    app_id: app_id,
    updating: "creating",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // handle input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [fileInput, fileChangeHandler] = useFileSelected(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  // Reset state
  const resetState = () => {
    setStaffInputData({
      ...staffInputData,
      institution_name: "",
      start_date: new Date().toISOString().slice(0, 10),
      end_date: new Date().toISOString().slice(0, 10),
      course_of_study: "",
      document: {},
      updating: "creating",
    });
    setError({ ...{} });
  };
  // fetch uploaded educational information
  const edu_info = () => staff_records.find((f) => f.educational_info);

  // submit form
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      dispatch(addStaffEducationalInfo(staffInputData));
    }
  };

  // delete educational info
  const handleDelete = (recordID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeStaffEducationalInfo(recordID));
      }
    });
  };

  // navigate to next page
  const proceedHandler = () => {
    navigate("/admin/add-staff/employment-information", {
      state: { from: location },
      replace: true,
    });
  };

  const breadcrumb = {
    from: {
      title: "Add Staff",
      link: "/admin/add-staff",
    },
    current: {
      title: "educational information",
      link: null,
    },
  };

  useEffect(() => {
    let education_info = edu_info();
    if (education_info) {
      setCurrentEducationalInfo(education_info);
    }
    if (isSuccess) {
      resetState();
    }
    return () => {
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isError, isSuccess, isLoading]);

  useEffect(() => {
    !app_id && navigate(-1);
    app_id &&
      pages.previousPage !== "CONTACT_INFORMATION" &&
      pages.previousPage !== "EDUCATIONAL_INFORMATION" &&
      nextPage &&
      navigate(nextPage, { state: { from: location }, replace: true });
  }, [pages]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create staff"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Staff Creation' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Educational Information
                  </h4>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  {error.start_date && (
                    <div className='alert alert-danger'>{error.start_date}</div>
                  )}
                </div>
              </div>
              <Form
                setError={setError}
                submitHandler={handleSubmit}
                values={staffInputData}
              >
                <div className='row g-'>
                  <div className='mb-0 col-md-4'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Institution Name (In full){" "}
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      textname='Institution name'
                      min_length='5'
                      name='institution_name'
                      onChange={handleChange}
                      value={input.institution_name}
                      type='text'
                      className={`form-control ${
                        error.institution_name && "is-invalid"
                      }`}
                      id='inputEmail4'
                      placeholder='Institution Name '
                    />
                    {error.institution_name && (
                      <span className='invalid-feedback'>
                        {error.institution_name}
                      </span>
                    )}
                  </div>
                  <div className='col-md-4'>
                    <div className='row'>
                      <div className='mb-0 col-md-6'>
                        <label htmlFor='inputEmail4' className='form-label'>
                          Start Date <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='date'
                          name='start_date'
                          value={input.start_date}
                          onChange={handleChange}
                          className='form-control'
                        />
                      </div>

                      <div className='mb-0 col-md-6'>
                        <label htmlFor='inputEmail4' className='form-label'>
                          End Date
                        </label>
                        <input
                          name='end_date'
                          value={input.end_date}
                          onChange={handleChange}
                          type='date'
                          className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='mb-0 col-md-4'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Course of Study <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='5'
                      textname='Course name'
                      name='course_of_study'
                      onChange={handleChange}
                      value={input.course_of_study}
                      type='text'
                      className={`form-control ${
                        error.course_of_study && "is-invalid"
                      }`}
                      id='inputEmail4'
                      placeholder='Enter Course Name'
                    />
                    {error.course_of_study && (
                      <span className='invalid-feedback'>
                        {error.course_of_study}
                      </span>
                    )}
                  </div>
                </div>
                <div className='my-3'>
                  <label
                    className='btn btn-primary'
                    htmlFor='certificate'
                    onClick={() => {
                      certicateRef.current.click();
                    }}
                  >
                    Browse Document
                  </label>
                  {fileInput.document && (
                    <a href='#' className='ms-2 text-col'>
                      {fileInput.document.name}
                    </a>
                  )}
                  <input
                    type='file'
                    className='invisible'
                    accept='image/*, application/pdf'
                    name='document'
                    onChange={fileChangeHandler}
                    ref={certicateRef}
                  />

                  <div className='float-end'>
                    <button
                      disabled={isLoading && true}
                      className='btn btn-success px-3'
                    >
                      Save{" "}
                    </button>
                  </div>
                  <div className='clearfix'></div>
                </div>
              </Form>
              {currentEducationalInfo?.educational_info &&
              currentEducationalInfo?.educational_info.length > 0 ? (
                <div>
                  <div className='col-sm-12 table-responsive mb-4'>
                    <table
                      className='table table-centered table-striped dt-responsive nowrap w-100 dataTable no-footer dtr-inline collapsed'
                      id='products-datatable'
                      aria-describedby='products-datatable_info'
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "27.6px" }}>#</th>
                          <th style={{ width: "117.8px" }}>Institution Name</th>
                          <th style={{ width: "106.8px" }}>Start Date</th>
                          <th style={{ width: "106.8px" }}>End Date</th>
                          <th style={{ width: "96.8px" }}>Course of Study</th>
                          <th style={{ width: "75.6px" }}>Document</th>
                          <th style={{ width: "55.8px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentEducationalInfo?.educational_info &&
                          currentEducationalInfo?.educational_info.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.institution_name}</td>
                                <td>{item.start_date}</td>
                                <td>{item.end_date}</td>
                                <td>{item.course_of_study}</td>
                                <td className='link-primary'>
                                  <a
                                    href='#'
                                    data-bs-toggle='modal'
                                    data-bs-target={`#doc${index}`}
                                  >
                                    {item.document}
                                  </a>
                                </td>
                                <td className='text-danger'>
                                  <a
                                    href='#'
                                    onClick={() => handleDelete(item.id)}
                                  >
                                    <i className='uil uil-times text-danger fs-4'></i>
                                  </a>
                                </td>
                                <td>
                                  <Preview
                                    document_url={item.document}
                                    id={`doc${index}`}
                                  />
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                  <button
                    onClick={proceedHandler}
                    className='btn btn-primary float-end'
                  >
                    Proceed
                  </button>
                </div>
              ) : (
                // !currentEducationalInfo?.educational_info &&
                <div className='alert alert-info mt-2'>No Record Found</div>
              )}
              {/* {!currentEducationalInfo?.educational_info &&
                                <div className='alert alert-info'> 
                                    No Record Found 
                                </div>
                            } */}
            </div>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  );
};

export default AddEducationInfo;
